import { z } from 'zod';
import { CnpjVO } from "../../../../common/validators/value-objects/cnpj.js";
import { BaseCompanyDTOSchema, } from "./companies.dto.js";
// Schema for input validation when creating a company
export const CreateCompanyInputDTOSchema = BaseCompanyDTOSchema.omit({
    id: true,
    slug: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
}).extend({
    name: z.string().min(2).max(32),
    legalName: z.string().min(2).max(128),
    cnpj: CnpjVO,
});
// Request and response schemas for the API layer
export const CreateCompanyRequestDTOSchema = z.object({
    body: CreateCompanyInputDTOSchema,
});
//# sourceMappingURL=create-company.dto.js.map